export const ProductData =[
    {
    id:1,
     name:'Asus Vivobook X515MA',
     price:35500,
     stock:20,
    },
    {
    id:2,
     name:'Dell E1916HV 18.5 Inch',
     price:9300,
     stock:35,
    },
    {
    id:3,
     name:'Canon Eos 4000D 18MP',
     price:36500,
     stock:72,
    }

]